module.exports = __webpack_public_path__ + "media/images/mobile-only/element04-de08ee3677bca29299c138cf5a712981.png";